module.exports = __webpack_public_path__ + "images/rich_heading/small_appliance/electric_tool/icon_001f25b840b46a0667887edbff75984c.png";